import React, { useMemo } from "react";
import Select from "react-select";
import ISO6391 from "iso-639-1";
import "./SpokenLanguage.css"; // Opcional, para estilos propios

const SpokenLanguage = ({
  languageList,
  value,
  onChange,
  placeholder,
  label,
  isDisabled = false,
}) => {
  // Se calcula la lista por defecto solo una vez
  const defaultLanguages = useMemo(() =>
    ISO6391.getAllCodes().map(code => ({
      value: code,
      label: ISO6391.getNativeName(code)
    })),
  []);

  // Se usa la lista pasada por props o la lista por defecto
  const options = useMemo(() => {
    const list = languageList || defaultLanguages;
    return list.map((lang) => ({ value: lang.value, label: lang.label }));
  }, [languageList, defaultLanguages]);

  const selected = useMemo(() => {
    return options.find((opt) => opt.value === value) || null;
  }, [options, value]);

  const handleChange = (opt) => {
    onChange(opt ? opt.value : "");
  };

  return (
    <div className="spoken-language-wrapper">
      {label && <label className="spoken-language-label">{label}</label>}
      <Select
        isDisabled={isDisabled}
        options={options}
        value={selected}
        onChange={handleChange}
        placeholder={placeholder || "Select a language"}
      />
    </div>
  );
};

export default SpokenLanguage;
